import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { styled } from "@material-ui/core/styles";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import useCustomState from "../../hooks/State";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Split } from "../../utils/Split";
import { LinearProgress } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Pie, Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { COLORS } from "../../utils/const";

const CountersPerCategoryChart = (props) => {
  // const projectsByCities = useSelector((state) => state.projectsByCities);

  const labels = Object.keys(props.categories);

  const backgroundColors = labels.map((l, idx) => COLORS[idx % COLORS.length]);

  const data = {
    labels: labels,
    datasets: [
      {
        data: labels.map((label, index) => props.categories[label]),
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    legend: { labels: { fontFamily: "Vazir" }, rtl: false },
    scales: {
      yAxes: [
        {
          display: false,
          ticks: {
            // fontSize: 40
            fontFamily: "Vazir",
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              return Split(convertNumbers(label));
            },
          },
        },
      ],
      xAxes: [
        {
          display: false,
          ticks: {
            fontFamily: "Vazir",
            userCallback: (label, index, labels) => {
              return convertNumbers(label);
            },
          },
          offset: true,
        },
      ],
    },
    tooltips: {
      bodyFontFamily: "Vazir",
      callbacks: {
        title: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return convertNumbers(data.labels[indice]);
        },
        label: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return (
            "کنتورهای " +
            labels[indice] +
            " - " +
            "تعداد کنتور" +
            ": " +
            Split(convertNumbers(data.datasets[0].data[indice])) +
            ""
          );
        },
      },
    },
  };

  return (
    <>
      {/* <Bar data={data} options={options} /> */}
      <Pie data={data} options={options} />
    </>
  );
};

export default CountersPerCategoryChart;
